export default __webpack_public_path__ + "static/media/eye_svg.e0663435.svg";